import { render } from "./Spinner.vue?vue&type=template&id=6b8b2b8e"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=6b8b2b8e&lang=css"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__